import { cn } from '@/utils/styles/cn'

export const Middot = ({ className }: { className?: string }) => (
    <span aria-hidden className={cn('text-fg-tertiary', className)}>
        ·
    </span>
)
